module.exports = __webpack_public_path__ + "img/icon_loading.c88c198c.svg";